import { windowWidth } from "src/styles/global";
import styled from "styled-components";

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: hidden;
  gap: 15px;

  > * {
    padding-left: 25px;
    padding-right: 25px;

    :last-child {
      padding-left: 0;
      padding-right: 0;
    }

    @media ( max-width: ${windowWidth.mobile.large} ) {
      padding-left: 15px;
      padding-right: 15px;

      /** step tabs and control buttons */
      :nth-child(2), :last-child {
        padding-left: 1px;
        padding-right: 1px;
      }
    }
  }
`;

const SaveUserButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  :first-child {
    font-size: 20px;
    line-height: 1;
    margin-left: 14px;
  }
`;

export { Container, SaveUserButton };